import React from 'react';
import { Link  } from "react-router-dom";
import { Utils } from '../../../Utils';
import i18n from '../../../i18n/i18n.js';

import './Radio.css';

class Radio extends React.Component {

  parent = null;
  
  constructor(props) {
    super(props);

    this.parent = typeof props.parent != 'undefine' ? props.parent : null;
    this.ws_data = typeof props.ws_data != 'undefine' ? props.ws_data : null;

    this.state = {};
  }

  render() {
    const {formData, formErrors} = this.parent.state;
    const parent = this.parent;
    const ws_data = this.ws_data;

    // ha nincs érték, akkor alapértelmezett érték kiválasztása
    if (formData[ws_data.fieldname] === '' && ws_data.default !== '')
    {
      formData[ws_data.fieldname] = ws_data.default;
    }

    return <div className="row">
      <div className={`field field_radio ${ws_data.fieldname} ${formErrors[ws_data.fieldname] !== '' ? "error" : ""}`}>
        <label>{`${ws_data.label} ${ws_data.required ? '*' : ''}`}</label>

        {Object.keys(ws_data.values).map((key) => {
          return <div key={key} className="radio">
            <input id={`${ws_data.fieldname}_${key}`} checked={parseInt(formData[ws_data.fieldname]) === parseInt(key)} type="radio" name={ws_data.fieldname} value={key} onChange={(e) => parent.handle_change(e, ws_data.fieldname, {item: ws_data})} /> 
            <label htmlFor={`${ws_data.fieldname}_${key}`}>{ws_data.values[key]}</label>
          </div>;
        })}

        {(formErrors[ws_data.fieldname].length) ? <div className="form_error">{formErrors[ws_data.fieldname]}</div> : '' } 
      </div>
    </div>;
  }
};

export default Radio;
